import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SeoService } from '../../core/services/seo.service';

@Component({
  selector: 'app-page404',
  imports: [FormsModule, TranslateModule],
  templateUrl: './page404.html',
  styleUrl: './page404.scss'
})
export class page404 implements OnInit {

  private seoService = inject(SeoService);

  ngOnInit(): void {
    this.seoService.setPageMetadata({
      title: 'Page Not Found - LuQta',
      description: 'The page you are looking for does not exist or has been moved. Return to LuQta homepage to explore our platform.',
      path: '/404',
      type: 'website',
      ogTitle: 'Page Not Found - LuQta',
      ogDescription: 'The page you are looking for does not exist. Return to LuQta homepage.',
      twitterTitle: 'Page Not Found - LuQta',
      twitterDescription: 'The page you are looking for does not exist. Return to LuQta homepage.'
    });
  }
}
